import { ContentCard, Success } from 'apps/dashboard/shared/scripts/components';
import { DeliveryMethod } from 'apps/shared/scripts/__generated__/graphql.generated';

interface Props {
  cardId: string;
  preference: string;
}

const CardDeliverySuccess = ({ cardId, preference }: Props) => {
  const isManual = preference === DeliveryMethod.Manual;

  return (
    <ContentCard>
      <Success
        cardId={cardId}
        primaryLabel="View Card"
        primaryUrl={`/${cardId}`}
        secondaryLabel="Manage Card"
        secondaryUrl={`/dashboard/cards/${cardId}`}
      >
        Your card was successfully {isManual ? 'published' : 'sent'}.
      </Success>
    </ContentCard>
  );
};

CardDeliverySuccess.displayName = 'CardDeliverySuccess';

export default CardDeliverySuccess;
